import React, { useState, useEffect } from "react";
import copy from "clipboard-copy";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { FaCopy, FaFileCsv, FaFileExcel, FaFilePdf, FaPrint } from "react-icons/fa";
import "../../Style/CrmDashBoardTable.css";
import OutsideClickHandler from "react-outside-click-handler";
import DataTable from "react-data-table-component";

function InteractionRecord({ tableData = [] }) {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const [value, setValue] = useState("");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    if (tableData?.length) {
      setItemsPerPage(4);
      setItemsPerPage(4);
    }
  }, [tableData]);

  const handleSort = (column, direction) => {
    if (column.sortField) {
      setSortColumn(column.sortField);
      setSortDirection(direction);
    }
  };

  // State flags for column visibility
  const [Direction, setDirection] = useState(true);
  const [Product, setProduct] = useState(true);
  const [Enquiry, setEnquiry] = useState(true);
  const [Status, setStatus] = useState(true);
  const [Duedate, setDuedate] = useState(true);
  const [Priority, setPriority] = useState(true);
  const [DateTime, setDateTime] = useState(true);
  const [User, setUser] = useState(true);
  const [Remarks, setRemarks] = useState(true);

  // Visibility toggle helpers
  const [visibile, setVisible] = useState(false);
  const handleDrop = () => setVisible(!visibile);

  const handleDirection = () => { setDirection(!Direction); setVisible(true); };
  const handleProduct = () => { setProduct(!Product); setVisible(true); };
  const handleEnquiry = () => { setEnquiry(!Enquiry); setVisible(true); };
  const handleStatus = () => { setStatus(!Status); setVisible(true); };
  const handlePriority = () => { setPriority(!Priority); setVisible(true); };
  const handleDuedate = () => { setDuedate(!Duedate); setVisible(true); };
  const handleDateTime = () => { setDateTime(!DateTime); setVisible(true); };
  const handleUser = () => { setUser(!User); setVisible(true); };
  const handleRemarks = () => { setRemarks(!Remarks); setVisible(true); };

  const [InteractionId, setInteractionId] = useState(true);
  const [CustomerName, setCustomerName] = useState(true);

  const columns = [
    {
      name: "Interaction ID",
      selector: (row) => row.id || row.uuid || "N/A",
      sortable: true,
      sortField: "id",
      omit: !InteractionId,
      minWidth: "140px",
    },
    {
      name: "Customer / Lead",
      selector: (row) => row.customerName || row.leadName || row.name || row.customerid || row.leadid || "N/A",
      sortable: true,
      sortField: "customerName",
      omit: !CustomerName,
      minWidth: "170px",
      wrap: true,
    },
    {
      name: "Interaction Type",
      selector: (row) => row.direction || row.interactionType || "",
      sortable: true,
      sortField: "direction",
      omit: !Direction,
      minWidth: "140px",
    },
    {
      name: "Product",
      selector: (row) => row.product || "",
      sortable: true,
      sortField: "product",
      omit: !Product,
      minWidth: "110px",
    },
    {
      name: "Enquiry",
      selector: (row) => row.enquiry || "",
      sortable: true,
      sortField: "enquiry",
      omit: !Enquiry,
      minWidth: "110px",
    },
    {
      name: "Status",
      selector: (row) => row.status || "",
      sortable: true,
      sortField: "status",
      omit: !Status,
      minWidth: "100px",
      cell: (row) => {
        const status = (row.status || "").toLowerCase();
        let badgeClass = "bg-success text-white";
        if (status === "open" || status === "pending") {
          badgeClass = "bg-warning text-dark";
        } else if (status === "close" || status === "closed") {
          badgeClass = "bg-secondary text-white";
        }
        return (
          <span className={`badge ${badgeClass} px-2 py-1`}>
            {row.status || "N/A"}
          </span>
        );
      },
    },
    {
      name: "Priority",
      selector: (row) => row.priority || row.preferences || "",
      sortable: true,
      sortField: "priority",
      omit: !Priority,
      minWidth: "110px",
      cell: (row) => {
        const priority = (row.priority || row.preferences || "").toLowerCase();
        let badgeClass = "bg-info text-white";
        if (priority === "critical" || priority === "emergency" || priority === "high") {
          badgeClass = "bg-danger text-white";
        } else if (priority === "medium" || priority === "normal") {
          badgeClass = "bg-primary text-white";
        } else if (priority === "low" || priority === "deferred") {
          badgeClass = "bg-secondary text-white";
        }
        return (
          <span className={`badge ${badgeClass} px-2 py-1`}>
            {row.priority || row.preferences || "N/A"}
          </span>
        );
      },
    },
    {
      name: "Due Date",
      selector: (row) => row.duedate || "",
      sortable: true,
      sortField: "duedate",
      omit: !Duedate,
      minWidth: "120px",
    },
    {
      name: "Date & Time",
      selector: (row) => row.createdAt || row.creationDate || row.date || row.interactionDate || "",
      sortable: true,
      sortField: "createdAt",
      omit: !DateTime,
      minWidth: "190px",
      cell: (row) => {
        const val = row.createdAt || row.creationDate || row.date || row.interactionDate;
        if (!val) return "";
        try {
          const date = new Date(val);
          return isNaN(date.getTime()) ? val : date.toLocaleString();
        } catch {
          return val;
        }
      },
    },
    {
      name: "User",
      selector: (row) => {
        let user = row.createdBy || row.assigned || "";
        if (user === localStorage.getItem("userId")) {
          user = localStorage.getItem("name") || "You";
        }
        return user;
      },
      sortable: true,
      sortField: "createdBy",
      omit: !User,
      minWidth: "140px",
    },
    {
      name: "Remarks",
      selector: (row) => row.notes || row.remarks || row.description || "",
      sortable: true,
      sortField: "notes",
      wrap: true,
      omit: !Remarks,
      minWidth: "240px",
      grow: 2,
    },
  ];

  // Filter and sort the data based on the selected column and direction
  const filteredData = tableData
    .filter((ele) =>
      value === ""
        ? true
        : Object.values(ele).some((val) =>
          val?.toString().toLowerCase().includes(value.toLowerCase())
        )
    )
    .sort((a, b) => {
      if (!sortColumn) return 0;

      // Extract values securely
      const aValue = a?.[sortColumn] ?? "";
      const bValue = b?.[sortColumn] ?? "";
      return aValue > bValue
        ? sortDirection === "asc"
          ? 1
          : -1
        : aValue < bValue
          ? sortDirection === "asc"
            ? -1
            : 1
          : 0;
    });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, filteredData.length);
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const handleSearch = (e) => {
    setValue(e.target.value);
  };

  const [copied, setCopied] = useState(false);

  const handleCopyClick = () => {
    const formattedData = JSON.stringify(tableData, null, 2);
    copy(formattedData);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const convertToJson = () => {
    const csv = Papa.unparse(tableData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", `interaction_records.csv`);
      link.setAttribute("download", `interaction_records.csv`);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const convertToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Interactions");
    XLSX.writeFile(workbook, `interaction_records.xlsx`);
  };

  const convertToPdf = () => {
    const doc = new jsPDF();
    const jsonString = JSON.stringify(tableData, null, 2);
    doc.text(jsonString, 10, 10);
    doc.save(`interaction_records.pdf`);
    doc.save(`interaction_records.pdf`);
  };

  const handlePrint = () => {
    const table = document.createElement("table");
    table.style.borderCollapse = "collapse";
    table.style.width = "100%";
    table.style.border = "1px solid #dee2e6";

    const tableBody = document.createElement("tbody");

    // Add Header
    const headerRow = tableBody.insertRow();
    headerRow.style.backgroundColor = "#f8f9fa";
    headerRow.style.borderBottom = "2px solid #dee2e6";

    const visibleCols = columns.filter(c => !c.omit);
    visibleCols.forEach(c => {
      const cell = headerRow.insertCell();
      cell.style.padding = "8px";
      cell.style.fontWeight = "bold";
      cell.style.border = "1px solid #dee2e6";
      cell.innerText = c.name;
    });

    // Add rows
    filteredData.forEach(row => {
      const bodyRow = tableBody.insertRow();
      bodyRow.style.borderBottom = "1px solid #dee2e6";
      visibleCols.forEach(c => {
        const cell = bodyRow.insertCell();
        cell.style.padding = "8px";
        cell.style.border = "1px solid #dee2e6";
        const val = c.selector(row);
        cell.innerText = typeof val === "object" ? "" : (val || "");
      });
    });

    table.appendChild(tableBody);

    const printWindow = window.open("", "_blank");
    printWindow.document.write(`
        <html>
        <head>
            <title>Print Table</title>
            <style>
              body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; padding: 20px; }
            </style>
        </head>
        <body>
            <h3>Interaction Records</h3>
            ${table.outerHTML}
        </body>
        </html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  // Custom styling for react-data-table-component
  const customStyles = {
    table: {
      style: {
        backgroundColor: '#ffffff',
      },
    },
    headRow: {
      style: {
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #dee2e6',
        borderBottom: '2px solid #dee2e6',
      },
    },
    headCells: {
      style: {
        fontSize: '13px',
        fontWeight: '700',
        color: '#495057',
        textTransform: 'uppercase',
        paddingLeft: '12px',
        paddingRight: '12px',
      },
    },
    rows: {
      style: {
        minHeight: '48px',
        fontSize: '14px',
        color: '#212529',
        '&:not(:last-of-type)': {
          borderBottom: '1px solid #dee2e6',
        },
      },
    },
    pagination: {
      style: {
        borderTop: '1px solid #dee2e6',
      },
    },
  };

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 my-3">
        {/* FIX: was `className="btn-group" role="group"` — Bootstrap's
            .btn-group class visually joins buttons together with negative
            margins, which removes the gap between them. Task.jsx never
            uses .btn-group; it uses a plain flex row with an explicit
            `gap`, which is what actually produces spaced-out buttons.
            Swapping to the same pattern here matches Task/Service/
            Quotation spacing without changing any button functionality. */}
        <div className="d-flex flex-wrap align-items-center" style={{ gap: "6px" }}>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handleCopyClick}
            title="Copy data"
          >
            <FaCopy />
            {copied ? "Copied!" : "Copy"}
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={convertToJson}
            title="Export CSV"
          >
            <FaFileCsv style={{ color: "#2e7d32" }} />
            CSV
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={convertToExcel}
            title="Export Excel"
          >
            <FaFileExcel style={{ color: "#1565c0" }} />
            Excel
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={convertToPdf}
            title="Export PDF"
          >
            <FaFilePdf style={{ color: "#c62828" }} />
            PDF
          </button>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={handlePrint}
            title="Print"
          >
            <FaPrint />
            Print
          </button>

          <OutsideClickHandler
            onOutsideClick={() => {
              setVisible(false);
            }}
          >
            <div className="position-relative">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm dropdown-toggle"
                onClick={handleDrop}
              >
                Column Visibility
              </button>

              <div
                className={`dropdown-menu ${visibile ? "show" : ""
                  } dropdown-menu-end`}
                style={{ right: 0, left: "auto", position: "absolute", zIndex: 1050 }}
              >
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleDirection}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Direction} readOnly className="form-check-input me-2" />
                  <span>Interaction Type</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleProduct}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Product} readOnly className="form-check-input me-2" />
                  <span>Product</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleEnquiry}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Enquiry} readOnly className="form-check-input me-2" />
                  <span>Enquiry</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleStatus}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Status} readOnly className="form-check-input me-2" />
                  <span>Status</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handlePriority}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Priority} readOnly className="form-check-input me-2" />
                  <span>Priority</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleDuedate}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Duedate} readOnly className="form-check-input me-2" />
                  <span>Due Date</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleDateTime}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={DateTime} readOnly className="form-check-input me-2" />
                  <span>Date & Time</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleUser}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={User} readOnly className="form-check-input me-2" />
                  <span>User</span>
                </div>
                <div
                  className="dropdown-item d-flex align-items-center"
                  onClick={handleRemarks}
                  style={{ cursor: "pointer" }}
                >
                  <input type="checkbox" checked={Remarks} readOnly className="form-check-input me-2" />
                  <span>Remarks</span>
                </div>
              </div>
            </div>
          </OutsideClickHandler>
        </div>

        <div className="d-flex align-items-center gap-2">
          <label htmlFor="search-input" className="mb-0 text-secondary" style={{ fontSize: "14px" }}>
            Search:
          </label>
          <input
            id="search-input"
            type="text"
            className="form-control form-control-sm"
            onChange={handleSearch}
            value={value}
            placeholder="Search details..."
            style={{ width: "200px" }}
          />
        </div>
      </div>

      <div className="table-container shadow-sm border rounded">
        <DataTable
          columns={columns}
          data={paginatedData}
          pagination
          paginationServer
          paginationTotalRows={filteredData.length}
          onChangePage={setCurrentPage}
          onChangeRowsPerPage={setItemsPerPage}
          sortServer
          onSort={handleSort}
          highlightOnHover
          striped
          customStyles={customStyles}
        />
      </div>
    </>
  );
}

export default InteractionRecord;
